define(function(require, exports, module) {
    'use strict';

    var $ = require('j');
    var _ = require('underscore');
    var core = require('core');
    var urlUtil = require('util/url.util');
    var config = require('config');
    var user = require('user');
    var PortletView = require('modules/portlet/portlet.view');
    var postMessageManager = require('managers/postMessage.manager.instance');
    var i18n = require('i18n');

    module.exports = PortletView.extend({

        className: 'cashier-iframe',

        accessRules: {
            allow: ['user']
        },

        cashierFrame: null,

        subscribe: function() {
            var eventName = 'safecharge:analytics';
            this.listenToOnce(core, eventName, this.sendPromoCode.bind(this, eventName));
        },

        close: function() {
            this.destroyPostMessages();
            PortletView.prototype.close.apply(this, arguments);
        },

        render: function(options) {
            var portletConfig = this.model.get('config');
            var id = this.cid;

            if (options && options.refresh) {
                this.destroyPostMessages();
            }

            this.model.getCashierUrl()
                .done(function(data) {
                    // if we navigated from page before response came
                    if (!document.body.contains(this.el)) {
                        return;
                    }

                    var form = this.tmpl('cashieriframe.form', data)[0];

                    this.$el.html(this.tmpl('cashieriframe', {
                        width: portletConfig.cashierWidth,
                        widthUnit: portletConfig.cashierWidthUnit,
                        height: portletConfig.cashierHeight,
                        heightUnit: portletConfig.cashierHeightUnit,
                        id: id
                    }));

                    form.setAttribute('target', 'cashierIframe_' + id);
                    form.setAttribute('action', data.url);
                    document.body.appendChild(form);
                    form.submit();
                    document.body.removeChild(form);
                    this.initPostMessages();
                }.bind(this))
                .fail(this.renderError.bind(this));

            return this;
        },

        portletDidMount: function() {
            // continue register for fast registered players
            if (user.isFastRegistered()) {
                return user.continueRegistration();
            }
        },

        renderError: function(error) {
            if (error.data && error.data.errorCode) {
                return this.renderNetworkError(error);
            }

            this.$el.html(this.tmpl('common.portletError', {
                tKey: 'playtech.mobile.system.sc-cashier.message.somethingWentWrong'
            }));
        },

        initPostMessages: function() {
            this.cashierFrame = this.$('.fn-cashier-iframe')[0];

            if (this.cashierFrame) {
                this.postMessageHandlerId = postMessageManager.addHandler({
                    source: this.cashierFrame.contentWindow,
                    callback: this._handleMessage.bind(this),
                    parse: true
                });
            }
        },

        destroyPostMessages: function() {
            postMessageManager.removeHandler(this.postMessageHandlerId);
        },

        sendPromoCode: function(eventName, data) {
            var urlParams = this.model.get('urlParams') || {};
            var promocode = urlParams.postParams && urlParams.postParams.promocode;

            if (data.action === 'saw') {
                promocode && postMessageManager.sendMessage(this.postMessageHandlerId, {
                    promocode: promocode
                });
            } else {
                // otherwise proceed listening
                this.listenToOnce(core, eventName, this.sendPromoCode.bind(this, eventName));
            }
        },

        resizeFrame: function(payload) {
            if (payload) {
                payload = _.isArray(payload) ? payload[0] : payload;

                this.$('.fn-cashier-iframe-container').css({
                    height: payload + 'px'
                });
            }
        },

        scrollTopHandler: function(payload) {
            if (payload) {
                payload = _.isArray(payload) ? payload[0] : payload;

                $('body')[0].scrollTop = payload;
            }
        },

        openAlternativeVerification: function(message) {
            var jumioResponseTarget = urlUtil.origin + '/' + config.get('themeName') +
                '/js/app-out/portlets/cashier-iframe/jumio-response-target.html' +
                '?type=documentVerify&domain=' + window.document.domain;

            var options = {
                errorUrl: jumioResponseTarget + '&status=error',
                successUrl: jumioResponseTarget + '&status=success',
                remotePaymentAccountId: message.payload.userPaymentOptionId
            };

            this.model.initiateDocumentUpload(options)
                .done(this.handleInitiateDocumentUploadSuccess.bind(this))
                .fail(this.handleInitiateDocumentUploadError.bind(this));

            return this;
        },

        handleInitiateDocumentUploadSuccess: function(response) {
            if (response.data && response.data.redirectURL) {
                this.cashierFrame.setAttribute('src', response.data.redirectURL);
            } else {
                this.showInfo({
                    content: this.translate('playtech.mobile.system.sc-cashier.jumio.generic.error')
                });
            }

            return this;
        },

        handleInitiateDocumentUploadError: function(response) {
            var message = response.data && i18n.tExt('playtech.mobile.system.sc-cashier.jumio.error.' + response.data.errorCode,
                response.data.errorMessage);

            this.showInfo({
                content: message || this.translate('playtech.mobile.system.sc-cashier.jumio.generic.error')
            });

            return this;
        },

        handleJumioResponse: function(status) {
            window.Playtech.API.popup.showPopup('jumioVerificationStatus', { status });
        },

        _handleMessage: function(message, parseError) {
            if (parseError) {
                core.warn('Message from Cashier Iframe can\'t be parsed:', message);
                return;
            }

            switch (message.action) {
                case 'resizeHeight':
                    this.resizeFrame(message.payload);
                    break;

                case 'scrollTop':
                    this.scrollTopHandler(message.payload);
                    break;

                case 'contactSupport':
                    core.trigger('chat:action:open');
                    core.trigger('safecharge:contactSupport', message.payload);
                    break;

                case 'refreshPage':
                    this.render({ refresh: true });
                    break;

                case 'success':
                    core.trigger('safecharge:deposit:success');
                    break;

                case 'analytics':
                    core.trigger('safecharge:analytics', message.payload);
                    break;

                case 'alternativeVerification':
                    core.trigger('safecharge:alternativeVerification', message.payload);
                    this.openAlternativeVerification(message);
                    break;

                case 'documentVerify':
                    this.render({ refresh: true });
                    this.handleJumioResponse(message.status);
                    break;

                case 'failedRegistration':
                    core.trigger('safecharge:failedRegistration', message.payload);
                    break;

                case 'successfulRegistration':
                    core.trigger('safecharge:successfulRegistration', message.payload);
                    break;

                case 'successfulWithdrawalRequest':
                    core.trigger('safecharge:successfulWithdrawalRequest', message.payload);
                    break;

                case 'failedWithdrawalRequest':
                    core.trigger('safecharge:failedWithdrawalRequest', message.payload);
                    break;
            }
        }

    });

});
